import { prefetchResources, withFinalForm } from '@ds-frontend/resource'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import uniq from 'lodash/uniq'
import { withRouter } from 'next/router'
import { connect } from 'react-redux'
import { compose } from 'redux'

import ContinueBookingView from 'common/widgets/Cart/widgets/ContinueBookingView'
import WithDataBlocker from 'hocs/WithDataBlocker'


export default compose(
  withRouter,
  connect((_, props) => {
    const language = props.cart.course_cards.map(i => i.language_id).filter(i => Boolean(i))
    return {
      language_id: uniq(language),
    }
  }),
  prefetchResources({
    namespace: 'thirdParty',
    endpoint: 'api/v2/public/third-party-services',
    queries: ['language_id'],
    reducer: 'replace',
  }),
  WithDataBlocker,
  withFinalForm({
    onSubmit: (data, _, props) => {
      const services = data.third_party_services.filter(i => i.is_selected)
      return props.bookingForm.create({
        ...props.cart,
        // `id` stays the option UUID (from the cart) — BE identifies the option by it.
        // The school is passed via `slug`, which fills the `:slug` URL param.
        slug: props.cart.school.slug,
        quoteId: props.state.quote,
        third_party_services: services,
      })
        .then(resp => {
          props.setBookingData({ ...props.state, cart: { ...resp, third_party_services: services, locale: props.router.locale, id: props.cart.id } })
          props.router.push('/booking')
        })
    },
    initialValues: props => ({
      third_party_services: get(props, 'thirdParty.data', []).map(service => {
        if(!isEmpty(props.cart.third_party_services)) {
          const subscriptionOption = props.cart.third_party_services.find(i => i.third_party_service_id === service.id)
          return subscriptionOption ? { ...subscriptionOption, is_selected: true } : {}
        }
        return {}
      }),
    }),
  },
  {
    endpoint: 'api/v2/public/schools/:slug/application-options/for-quote/:quoteId',
    namespace: 'bookingForm',
  },
  { prefetch: false }),
)(ContinueBookingView)
